import { DEFAULT_POLICY_NAME } from '@/common/constants/policy.constants';
import Ordering from '@/common/constants/ordering.constants';

export default function sortStoragePoliciesByName(a, b): number {
  if (a.name === DEFAULT_POLICY_NAME || a === DEFAULT_POLICY_NAME) {
    return Ordering.Less;
  }

  if (b.name === DEFAULT_POLICY_NAME || b === DEFAULT_POLICY_NAME) {
    return Ordering.Greater;
  }

  if (a.name && b.name) {
    return a.name.localeCompare(b.name);
  }

  return a.localeCompare(b);
}
